import { RootState } from "app/store";

export const selectPendingInvokeCall = (state: RootState) =>
    state.messages.pendingInvokeCall;
